// src/app/guards/layout.guard.ts
import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { GlobalService } from '../shared/services/global-data/global.service';
import { desktopRoutes } from './desktop.routes';
import { mobileRoutes } from './mobile.routes';

export const layoutGuard: CanMatchFn = (route) => {
  const globalService = inject(GlobalService);
  const isMobile = globalService.isMobileStyle;

  if (isMobile) {
    (route as any).children = mobileRoutes;
  } else {
    (route as any).children = desktopRoutes;
  }

  return true;
};